import React, { Component } from "react";
import {
  Modal,
  Switch,
  Spin,
  Input,
  Tooltip,
  Select,
  Pagination,
  Empty,
  Button,
  Upload,
  AutoComplete
} from "antd";
import formDataSchema from "../../../../schema/user-list";
import networkList from "../../../../constants/networkList";
import postService from "../../../../services/httpService";
import userTrackService from "./../../../../services/usertrack-service";
import { doctorlistfilter, serverListFilter, usersListFilter } from '../../../../schema/doctors';
import { CloudUploadOutlined, DeleteOutlined, PictureOutlined } from '@ant-design/icons';
import formDataPostService from "../../../../services/httpformData";
import { EyeOutlined , EditOutlined} from '@ant-design/icons';


const $ = require("jquery");
const { Option } = Select;
const { Search } = Input;
class User_List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      pageSize: 20,
      date: "",
      totalItemsCount: 0,
      showPagination: false,
      loadding: false,
      thead: [],
      showFilter: true,
      tbody: [],
      showAdd: false,
      showEdit: false,
      tableTitle: "",
      addText: "",
      formData: [],
      selected_proceure: {},
      fetching: false,
      doctorList: [],
      selected_doctor: {},
      anesthesiaList: [],
      selected_anesthesia: {},
      search_key: '',
      uid: null,
      fileList: [],
      viewimage: false,
      matchingRecords: [],
      matchingDoctorNames: [],
      doctorImage: ''
    };
  }
  componentDidMount() {
    let { id, slug } = this.props.match.params;
    let { menuList } = this.props;

    if (slug === "doctors") {
      this.doctorList("");
    }
    menuList.map((menu) => {
      if (slug !== undefined && slug !== null && slug !== "") {
        if (menu["route"] === id) {
          menu["submenu"].map((smenu) => {
            if (smenu["route"] === slug) {
              this.setState((state) => ({
                showAdd: JSON.parse(smenu["permissions"]["add"]),
                showEdit: JSON.parse(smenu["permissions"]["edit"]),
              }));
            }
          });
        }
      }
    });

    this.setState(
      (state) => ({ loadding: true, search_key: '' }),
      () => {
        this.fetchData(this.state.formData);
        this.loadPage();
      }
    );
    let formSchema = Object.assign({}, formDataSchema);
    this.setState({ formData: formSchema["feilds"], search_key: '' });

    if (slug === "tv-screens") {
      let search = window.location.search
      let params = new URLSearchParams(search);
      let uid = params.get('uid');
      if (uid !== undefined && uid !== '' && uid !== null) {
        this.setState({ uid: uid });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    try {
      let { id, slug } = this.props.match.params;
      let { menuList } = this.props;
      let prevSlug = prevProps.match.params.slug;
      if (slug !== prevSlug) {
        menuList.map((menu) => {
          if (slug !== undefined && slug !== null && slug !== "") {
            if (menu["route"] === id) {
              menu["submenu"].map((smenu) => {
                if (smenu["route"] === slug) {
                  this.setState((state) => ({
                    showAdd: JSON.parse(smenu["permissions"]["add"]),
                    showEdit: JSON.parse(smenu["permissions"]["edit"]),
                  }));
                }
              });
            }
          }
        });
        let formSchema = Object.assign({}, formDataSchema);
        formSchema["feilds"].map((feild, key) => {
          formSchema["feilds"][key]["value"] = null;
        });
        this.setState(
          (state) => ({
            loadding: true,
            activePage: 1,
            totalItemsCount: 0,
            search: false,
            searchwords: "",
            formData: formSchema["feilds"],
            search_key: ''
          }),
          () => {
            this.loadPage();
          }
        );
      }
    } catch (error) {
      console.log(error);
    }
  }
  fetchData(fetchData) {
    var payload = {
      unit_id: null,
      page: this.state.activePage,
    };
  
  }
  itemRender(current, type, originalElement) {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return originalElement;
  }
  componentWillUnmount() {
    $("footer").css({ position: "relative", top: "unset" });
    let search_key = '';
    this.setState({ search_key: search_key })

  }

  loadPage = (search_key) => {
    try {
      let { activePage } = this.state;
      let data = [];
      let { slug } = this.props.match.params;
    
      const {
        getRolesList,
        getUsersList,
        proceduresList,
        doctorsList,
        anaestheticiansList,
        getMasterUnitsList,
        blocksList,
        floorsList,
        OTRoomsList,
        getServicesList,
        master_unit,
        getWorkStations,
        getDepartmentsList,
        getMasterServicesList,
        getDoctorsList,
        getTvDisplays,
      } = networkList;
      let tableHead = [];
      switch (slug) {
        case "users":
          tableHead = [
            {
              key: "s_no",
              text: "s.no",
            },
            {
              key: "username",
              text: "user Name",
            },
            {
              key: "rh_userid",
              text:"user ID",
            },
            {
              key: "rolename",
              text: "Role",
            },
            // {
            //   key: "access_name",
            //   text: "Access Level",
            // },
            {
              key: "unitids",
              text: "Unit",
            },
            {
              key: "status",
              text: "Status",
            },
            {
              key: "action",
              text: "Action",
            },
          ];

          this.setState(
            (state) => ({
              search: false,
              showFilter: search_key ? true : false,
              addText: "User",
              tableTitle: "User List",
              thead: tableHead,
              loadding: true,
            }),
            () => {
              let payload = {
                "page_no": this.state.activePage,
                "search_key": search_key ? search_key : ''
              }
              postService(getUsersList, "POST", { data: payload }).then((res) => {
                if (res.status) {
                  this.setState((state) => ({
                    tbody: res.data,
                    loadding: false,
                    totalItemsCount: res.total_items,
                    showPagination: true,
                    showFilter: true,
                  }));
                
                }
                else {
                  this.setState({
                    loadding: false,
                    tbody: [],
                    totalItemsCount: 0,
                    showPagination: false,

                  })
                }
              });
            }
          );
          break;
        case "roles":
          tableHead = [
            {
              key: "s_no",
              text: "s.no",
            },
            {
              key: "name",
              text: "Role Name",
            },
            {
              key: "id",
              text: "Role Code",
            },
            {
              key: "status",
              text: "Status",
            },
            {
              key: "action",
              text: "Action",
            },
          ];
          this.setState(
            (state) => ({
              search: false,
              showFilter: false,
              addText: "Role",
              tableTitle: "Roles List",
              thead: tableHead,
            }),
            () => {
              postService(getRolesList, "GET", null).then((res) => {
                if (res.status) {
                  this.setState((state) => ({
                    tbody: res.data,
                    loadding: false,
                    totalItemsCount: res.data.length,
                    showPagination: false,
                  }));
                }
                else {
                  this.setState({
                    loadding: false,
                    tbody: [],
                    totalItemsCount: 0,
                    showPagination: false,
                  })
                }
              });
            }
          );
          break;
        case "doctors":
          tableHead = [
            {
              key: "s_no",
              text: "s.no",
            },
            {
              key: "name",
              text: "Doctor Name",
            },
            {
              key: "doctor_id",
              text: "Doctor Code",
            },
            {
              key: "specialization_code",
              text: "Department",
            },
            {
              key: "profile_pic",
              text: "Upload Profile",
            },
            {
              key: "status",
              text: "Status",
            },
            {
              key: "action",
              text: "Action",
            },
            {
              key:"vitals_required",
              text:"Vitals",
            }
          ];
          this.setState(
            (state) => ({
              search: true,
              loadding: true,
              showFilter: search_key ? true : false,
              addText: "Doctor",
              tableTitle: "Doctors List",
              thead: tableHead,
              tbody: []
            }),
            () => {
              let payload = {
                "page_no": this.state.activePage,
                "search_key": search_key ? search_key : '',
                "unit": "",
                "department_id": ""
              }
              postService(getDoctorsList, "POST", { data: payload }).then((res) => {
                if (res.status) {
                  this.setState((state) => ({
                    tbody: res.data,
                    loadding: false,
                    totalItemsCount: res.total_items,
                    data: data,
                    showPagination: true,
                    showFilter: true,
                  }));
                } else {
                  this.setState({
                    loadding: false,
                    tbody: [],
                    totalItemsCount: 0,
                    showPagination: false,
                  })
                }
              });
            }
          );
          break;
        case "service-group":
          tableHead = [
            {
              key: "s_no",
              text: "s.no",
            },
            {
              key: "name",
              text: "Service Group",
            },
            {
              key: "id",
              text: "Service Group Code",
            },
            {
              key: "departmentname",
              text: "Departement",
            },
            {
              key: "status",
              text: "Status",
            },
            {
              key: "action",
              text: "Action",
            },
          ];
          this.setState(
            (state) => ({
              search: true,
              loadding: true,
              showFilter: false,
              addText: "Service Group",
              tableTitle: "Service Group List",
              thead: tableHead,
            }),
            () => {
              postService(getServicesList, "GET", null).then((res) => {
                if (res.status) {
                  this.setState((state) => ({
                    tbody: res.data,
                    loadding: false,
                    totalItemsCount: res.data.length,
                    data: data,
                    showPagination: true,
                  }));
                }
                else {
                  this.setState({
                    loadding: false,
                    tbody: [],
                    totalItemsCount: 0,
                    showPagination: false,
                  })
                }
              });
            }
          );
          break;
        case "service-group":
          tableHead = [
            {
              key: "s_no",
              text: "s.no",
            },
            {
              key: "name",
              text: "Service Group",
            },
            {
              key: "id",
              text: "Service Group Code",
            },
            {
              key: "departmentname",
              text: "Departement",
            },
            {
              key: "status",
              text: "Status",
            },
            {
              key: "action",
              text: "Action",
            },
          ];
          this.setState(
            (state) => ({
              search: true,
              loadding: true,
              showFilter: false,
              addText: "Service Group",
              tableTitle: "Service Group List",
              thead: tableHead,
            }),
            () => {
              postService(getServicesList, "GET", null).then((res) => {
                if (res.status) {
                  this.setState((state) => ({
                    tbody: res.data,
                    loadding: false,
                    totalItemsCount: res.data.length,
                    data: data,
                    showPagination: true,
                  }));
                }
                else {
                  this.setState({
                    loadding: false,
                    tbody: [],
                    totalItemsCount: 0,
                    showPagination: false,
                  })
                }
              });
            }
          );
          break;
        case "units":
          tableHead = [
            {
              key: "s_no",
              text: "s.no",
            },
            {
              key: "name",
              text: "Unit",
            },
            {
              key: "id",
              text: "Unit Code",
            },
            {
              key: "address",
              text: "Unit Address",
            },
            {
              key: "status",
              text: "Status",
            },
            {
              key: "action",
              text: "Action",
            },
          ];
          this.setState(
            (state) => ({
              search: true,
              loadding: true,
              showFilter: false,
              addText: "Unit",
              tableTitle: "Unit List",
              thead: tableHead,
            }),
            () => {
              postService(master_unit, "GET", null).then((res) => {
                if (res.status) {
                  this.setState((state) => ({
                    tbody: res.data,
                    loadding: false,
                    totalItemsCount: res.data.length,
                    data: data,
                    showPagination: false,
                  }));
                } else {
                  this.setState({
                    loadding: false,
                    tbody: [],
                    totalItemsCount: 0,
                    showPagination: false,
                  })
                }
              });
            }
          );
          break;
        case "work-stations":
          tableHead = [
            {
              key: "s_no",
              text: "s.no",
            },
            {
              key: "unitname",
              text: "Unit Name",
            },
            {
              key: "work_station_name",
              text: "Workstation Name",
            },
            {
              key: "cabin_count",
              text: "cabin count",
            },
            {
              key: "tv_url",
              text: "Tv Url",
            },
            {
              key: "status",
              text: "Status",
            },
            {
              key: "action",
              text: "Action",
            },
          ];
          this.setState(
            (state) => ({
              search: true,
              loadding: true,
              showFilter: false,
              addText: "Work Station",
              tableTitle: "Work Station List",
              thead: tableHead,
            }),
            () => {
              postService(getWorkStations, "Post", {
                page_no: 1,
              }).then((res) => {
                if (res.status) {
                  this.setState((state) => ({
                    tbody: res.data,
                    loadding: false,
                    totalItemsCount: res.data.length,
                    data: data,
                    showPagination: false,
                  }));
                } else {
                  this.setState({
                    loadding: false,
                    tbody: [],
                    totalItemsCount: 0,
                    showPagination: false,
                  })
                }
              });
            }
          );
          break;
        case "departments":
          tableHead = [
            {
              key: "s_no",
              text: "s.no",
            },
            {
              key: "name",
              text: "Department",
            },
            {
              key: "id",
              text: "Department Code",
            },

            {
              key: "status",
              text: "Status",
            },
            {
              key: "action",
              text: "Action",
            },
          ];
          this.setState(
            (state) => ({
              search: true,
              loadding: true,
              showFilter: search_key ? true : false,
              addText: "Department",
              tableTitle: "Department List",
              thead: tableHead,
            }),
            () => {
              let payload = {
                "page_no": this.state.activePage,
                "search_key": search_key ? search_key : ''
              }
              postService('getDepartmentsListPage', "POST",  {data: payload }).then((res) => {
                if (res.status) {
                  this.setState((state) => ({
                    tbody: res.data,
                    loadding: false,
                    totalItemsCount: res.total_items,
                    data: data,
                    showPagination: true,
                    showFilter: true,
                  }));
                  console.log("daata",res.data);
                } else {
                  console.log("satya")
                  this.setState({
                    loadding: false,
                    tbody: [],
                    totalItemsCount: 0,
                    showPagination: false,
                  })
                }}); }
          );
          break;
        case "tv-screens":
          tableHead = [
            {
              key: "s_no",
              text: "S_no",
            },
            {
              key: "display_name",
              text: "Display Name",
            },
            {
              key: "queue_list",
              text: "Queues",
            },
            {
              key: "display_name",
              text: "Display Link"
            },
            // {
            //   key: "work_station",
            //   text: "Work Station"
            // },
            {
              key: "status",
              text: "Status",
            },
            {
              key: "action",
              text: "Action",
            },
          ];
          this.setState(
            (state) => ({
              addText: "Tv-Display",
              tableTitle: "Tv-Display Screens",
              thead: tableHead,
            }),
            () => {
              postService(getTvDisplays, "GET", null).then((res) => {
             
                if (res.status) {
                  this.setState((state) => ({
                    tbody: res.data,
                    loadding: false,
                    totalItemsCount: res.data.length,
                    showPagination: false,
                  }));
                } else {
                  this.setState({
                    loadding: false,
                    tbody: [],
                    totalItemsCount: 0,
                    showPagination: false,
                  })
                }
              });
            }
          );
          break;
        case "services":
          tableHead = [
            {
              key: "s_no",
              text: "s.no",
            },
            {
              key: "name",
              text: "Service",
            },
            {
              key: "id",
              text: "Service Code",
            },
            {
              key: "service_group_name",
              text: "Service Group",
            },

            {
              key: "status",
              text: "Status",
            },
            {
              key: "action",
              text: "Action",
            },
          ];
          this.setState(
            (state) => ({
              search: true,
              loadding: true,
              showFilter: search_key ? true : false,
              addText: "Service",
              tableTitle: "Service List",
              thead: tableHead,
            }),
            () => {
              let payload = {
                "page_no": this.state.activePage,
                "search_key": search_key ? search_key : ''
              }
              postService('getMasterServicesListPage', "POST", { data: payload }).then((res) => {
                if (res.status) {
                  this.setState((state) => ({
                    tbody: res.data,
                    loadding: false,
                    totalItemsCount: res.total_items,
                    data: data,
                    showPagination: true,
                    showFilter: true,
                  }));
                }
                else {
                  this.setState({
                    loadding: false,
                    tbody: [],
                    totalItemsCount: 0,
                    showPagination: false,
                  })
                }
              });
            }
          );
          break;
        default:
          break;
      }
    } catch (error) {
      console.log(error);
    }
  };

  onChange(checked, data) {
    try {
      const {
        changeUserStatus,
        changeCounsellingStationStatus,
        changeOTRoomsStatus,
        changeProceduresStatus,
        doctorsStatusSwitch,
        changeWorkStationStatus,
        changeTvDisplayStatus,
        changeStatusForDoctorList,
      } = networkList;
      let { slug } = this.props.match.params;
      let obj = {};
   
      switch (slug) {
        case "users":
          this.setState(
            (state) => ({ loadding: true }),
            () => {
              this.loadPage();
            }
          );
          obj = { user_id: data["id"], status: 0 };
          if (checked) {
            obj["status"] = 1;
          }

          postService("changeUserStatus", "POST", { data: obj }).then((res) => {
         
            if (res.status) {
              let This = this;
              Modal.success({
                title: "Success message",
                content: res["message"],
                onOk: function () {
                  This.setState(
                    (state) => ({ loadding: false, showPagination: false }),
                    () => {
                      This.loadPage();
                    }
                  );
                },
              });
              // this.setState((state) => ({ tbody: res.data, loadding: false }));
            } else {
              this.setState((state) => ({ loadding: false }));
              Modal.error({
                title: "Error message",
                content: "Something went wrong. Please,try again later",
                onOk: function () {
                  window.scrollTo(0, 0);
                },
              });
            }
          });
          break;
        case "tv-screens":
          this.setState(
            (state) => ({ loadding: true }),
            () => {
              this.loadPage();
            }
          );
          obj = { tv_display_id: data["tv_display_id"], status: 0 };
          if (checked) {
            obj["status"] = 1;
          }
          postService(changeTvDisplayStatus, "POST", { data: obj }).then(
            (res) => {
          
              if (res.status) {
                let This = this;
                Modal.success({
                  title: "Success message",
                  content: res["message"],
                  onOk: function () {
                    This.setState(
                      (state) => ({ loadding: false, showPagination: false }),
                      () => {
                        This.loadPage();
                      }
                    );
                  },
                });
                // this.setState((state) => ({ tbody: res.data, loadding: false }));
              } else {
                this.setState((state) => ({ loadding: false }));
                Modal.error({
                  title: "Error message",
                  content: "Something went wrong. Please,try again later",
                  onOk: function () {
                    window.scrollTo(0, 0);
                  },
                });
              }
            }
          );
          break;
        case "work-stations":
          this.setState(
            (state) => ({ loadding: true }),
            () => {
              this.loadPage();
            }
          );
          obj = { cs_id: Number(data["id"]), status: 0 };
          if (checked) {
            obj["status"] = 1;
          }

          postService(changeWorkStationStatus, "POST", obj).then((res) => {
         
            if (res.status) {
              let This = this;
              Modal.success({
                title: "Success message",
                content: res["message"],
                onOk: function () {
                  This.setState(
                    (state) => ({ loadding: false, showPagination: false }),
                    () => {
                      This.loadPage();
                    }
                  );
                },
              });
              // this.setState((state) => ({ tbody: res.data, loadding: false }));
            } else {
              this.setState((state) => ({ loadding: false }));
              Modal.error({
                title: "Error message",
                content: "Something went wrong. Please,try again later",
                onOk: function () {
                  window.scrollTo(0, 0);
                },
              });
            }
          });
          break;
        case "doctors":
          this.setState(
            (state) => ({ loadding: true }),
            () => {
              this.loadPage();
            }
          );
          if(checked=="vitals_required_true"|| checked== "vitals_required_false"){
            if(checked == "vitals_required_true"){
              obj = { id: Number(data["id"]), vitals_required: true,name:"vitals" };
            }
            else{
              obj = { id: Number(data["id"]), vitals_required: false,name:"vitals" };
            }
          }
          
          else{
          obj = { id: Number(data["id"]), status: 0, name:"status" };
          if (checked) {
            obj["status"] = 1;
          }}
       
          postService(changeStatusForDoctorList, "POST", { data: obj }).then(
            (res) => {
          
              if (res.status) {
                let This = this;
                Modal.success({
                  title: "Success message",
                  content: res["message"],
                  onOk: function () {
                    This.setState(
                      (state) => ({ loadding: false, showPagination: false }),
                      () => {
                        This.loadPage();
                      }
                    );
                  },
                });
              } else {
                this.setState((state) => ({ loadding: false }));
                Modal.error({
                  title: "Error message",
                  content: "Something went wrong. Please,try again later",
                  onOk: function () {
                    window.scrollTo(0, 0);
                  },
                });
              }
            }
          );
          break;
        default:
          break;
      }
    } catch (error) {
    
      this.setState((state) => ({ loadding: false }));
      Modal.error({
        title: "Error message",
        content: "Something went wrong. Please,try again later",
        onOk: function () {
          window.scrollTo(0, 0);
        },
      });
    }
  }
  addUser = () => {
    let { slug } = this.props.match.params;
    switch (slug) {
      case "users":
        this.props.history.push(`/settings/add-user`);
        break;
      case "roles":
        this.props.history.push(`/settings/add-role`);
        break;
      case "doctors":
        this.props.history.push(`/settings/add-doctor`);
        break;
      case "tv-screens":
        this.props.history.push(`/settings/addtvscreen`);
        break;
      case "work-stations":
        this.props.history.push(`/settings/add-work-stations`);
        break;
      case "units":
        this.props.history.push(`/settings/add-units`);
        break;
      case "service-group":
        this.props.history.push(`/settings/add-service-group`);
        break;
      case "departments":
        this.props.history.push(`/settings/add-departments`);
        break;
      case "services":
        this.props.history.push(`/settings/add-services`);
        break;
      default:
        break;
    }
  };
  editUser = () => {
    this.props.history.push(`/settings/edituser`);
  };
  userDetails = () => {
    this.props.history.push(`/settings/user-details`);
  };
  viewDetails(data) {
    try {
      let { slug } = this.props.match.params;
      if (slug === "users") {
        this.props.history.push("/settings/view-user?rid=" + data["id"]);
      }
      if (slug === "doctors") {
        this.props.history.push("/settings/view-doctor?rid=" + data["id"]);
      }
      if (slug === "roles") {
        this.props.history.push("/settings/view-role?rid=" + data["id"]);
      }
      if (slug === "service-group") {
        this.props.history.push(
          "/settings/view-service-group?rid=" + data["id"]
        );
      }
      if (slug === "units") {
        this.props.history.push("/settings/view-units?rid=" + data["id"]);
      }
      if (slug === "work-stations") {
        this.props.history.push(
          "/settings/view-work-stations?rid=" + data["id"]
        );
      }
      if (slug === "departments") {
        this.props.history.push("/settings/view-departments?rid=" + data["id"]);
      }
      if (slug === "services") {
        this.props.history.push("/settings/view-services?rid=" + data["id"]);
      }
      if (slug === "tv-screens") {
        this.props.history.push(
          "/settings/viewtvscreen?rid=" + data["tv_display_id"]
        );
      }
    } catch (error) {
      console.log(error);
    }
  }
  editclick(data) {
    try {
      let { slug } = this.props.match.params;
      if (slug === "users") {
        this.props.history.push("/settings/edit-user?rid=" + data["id"]);
      }
      if (slug === "doctors") {
        this.props.history.push("/settings/edit-doctor?rid=" + data["id"]);
      }
      if (slug === "roles") {
        this.props.history.push("/settings/edit-role?rid=" + data["id"]);
      }
      if (slug === "tv-screens") {
        this.props.history.push(
          "/settings/edittvscreen?rid=" + data["tv_display_id"]
        );
      }
      if (slug === "work-stations") {
        this.props.history.push(
          "/settings/edit-work-stations?rid=" + data["id"]
        );
      }
      if (slug === "service-group") {
        this.props.history.push(
          "/settings/edit-service-group?rid=" + data["id"]
        );
      }
      if (slug === "units") {
        this.props.history.push("/settings/edit-units?rid=" + data["id"]);
      }
      if (slug === "departments") {
        this.props.history.push("/settings/edit-departments?rid=" + data["id"]);
      }
      if (slug === "services") {
        this.props.history.push("/settings/edit-services?rid=" + data["id"]);
      }
    } catch (error) {
      console.log(error);
    }
  }
  handleChange(ele) {

    if (ele.name === "search") {
      this.setState({
        searchwords: ele.value,
      });
    }
  }
  handlePageChange(page) {
 
    this.setState(
      (state) => ({
        activePage: page,
      }),
      () => {
        this.loadPage();
      }
    );

    this.setState({ activePage: page });
  }
  search = () => {
    // let {search}=this.state
    this.setState(
      (state) => ({
        activePage: 1,
        totalItemsCount: 0,
      }),
      () => {
        this.loadPage();
      }
    );
  };

  selectedDoctor(id) {
    let { doctorList } = this.state;
    doctorList.map((data) => {
      if (id === 0) {
        this.setState(
          (state) => ({
            selected_doctor: {},
            searchwords: "",
            activePage: 1,
            totalItemsCount: 0,
          }),
          () => {
            // this.props.rerenderSlotsData(parseInt(5));
            this.loadPage();
          }
        );
      } else if (data.id === id) {
        this.setState(
          (state) => ({
            selected_doctor: data,
            searchwords: data.name,
            activePage: 1,
            totalItemsCount: 0,
          }),
          () => {
            // this.props.rerenderSlotsData(parseInt(5));
            this.loadPage();
          }
        );
      } else {
        console.log("else");
      }
    });
  }
  selectedAnesthesia(id) {
    let { anesthesiaList } = this.state;
    anesthesiaList.map((data) => {
      if (id === 0) {
        this.setState(
          (state) => ({
            selected_anesthesia: {},
            searchwords: "",
            activePage: 1,
            totalItemsCount: 0,
          }),
          () => {
            // this.props.rerenderSlotsData(parseInt(5));
            this.loadPage();
          }
        );
      } else if (data.id === id) {
        this.setState(
          (state) => ({
            selected_anesthesia: data,
            searchwords: data.name,
            activePage: 1,
            totalItemsCount: 0,
          }),
          () => {
            // this.props.rerenderSlotsData(parseInt(5));
            this.loadPage();
          }
        );
      } else {
        console.log("else");
      }
    });
  }
  doctorList = (search_key) => {
    let payload = {
      data_count: 0,
      search_key: search_key ? search_key : "",
    };
    // this.setState(
    //   (state) => ({ fetching: true, doctorList: [] }),
    //   () => {
    //     postService("doctorsSearchdropdown", "POST", payload).then((res) => {
    //       if (res.status) {
    //         this.setState((state) => ({
    //           fetching: false,
    //           doctorList: res["data"],
    //         }));
    //       } else {
    //         this.setState((state) => ({ fetching: false, doctorList: [] }));
    //       }
    //     });
    //   }
    // );
  };
  searchChange(e) {
    let value = e.target.value;
    this.setState(
      { search_key: value, page_data_count: 1 },
      () => {
        this.fetchMatchingRecords(value);
        this.loadPage(value);
      }
    );
  }
  searchClick() {
    
    let { search_key } = this.state;
   this.setState({ activePage: 1 }, () => {
      this.fetchMatchingRecords(search_key);
      this.loadPage(search_key);
    });
  }
  updatesearchkey(value){
console.log("searck key",value);
    this.setState({search_key:value});
    this.setState({ activePage: 1 }, () => {
      this.fetchMatchingRecords(value);
      this.loadPage(value);
    });
  }
  handle2Change = ({ fileList }) => {
    let file = null,
      file_type = null,
      file_name = null,
      file_size = null;
    if (fileList) {
      // fileList.map(async(item, key) =>
      for (let i = 0; i < fileList.length; i++) {
        let item = fileList[i]
        let key = i
        // fileList[key]['status'] = 'done';
        // fileList[key]['base_64'] = await getBase64(file.originFileObj);            
        file = item.originFileObj;
        file_type = item.type;
        file_name = item.name;
        file_size = item.size;
        // check file type
        const isJpgOrPngOrPdf = file_type == 'image/png' || file_type == 'image/jpg' || file_type == 'image/jpeg';

        const isLt2M = file_size < 300000;
        if (!isJpgOrPngOrPdf) {
          Modal.error({
            title: `(${file_name}) is invalid file.`,
            content: `Please, upload the following extensions files (.png/.jpg) smaller than 300KB only.`,
            zIndex: '1022'
          });
        }
        // check file size        
        else if (!isLt2M) {
          Modal.error({
            title: `(${file_name}) is invalid file.`,
            content: `Please, upload the file smaller than 300KB only.`,
            zIndex: '1022'
          });
        }

        else {
        
          this.resubmit(file)

        }
      }
      // );
    }

  };
  resubmit = (file) => {

    let user_data = null
    const { id, slug } = this.props.match.params;
    if (localStorage.getItem('user_data') !== null) {
      user_data = JSON.parse(localStorage.getItem('user_data'))
    } else {
      Modal.error({
        title: `Failure`,
        content: `unit in null.`,
        zIndex: '1022'
      });
    }
    let { body } = this.state
    if (file && body && body.id) {
      let doctorname = body.name.replace(/\s/g, '');
      doctorname = doctorname.replace('.', '');
      var num = body.id;
      var doc_id = num.toString();
      var form_data = new FormData();
      form_data.append('upfile', file);
      form_data.append("doctorid", body.id);
      form_data.append("doctorName", doctorname + '.jpg');
      if (body.profile_pic !== null && body.profile_pic !== '' && body.profile_pic !== undefined) {
        let This = this
        Modal.confirm({
          title: `Confirmation`,
          content: `Are you sure you want to upload a new image?`,
          zIndex: '1022',
          okText: "Ok",
          cancelText: "Cancel",
          onOk: function () {
            try {
              This.setState({ loadding: true })
              formDataPostService('profileUploadForDoctor', 'POST', form_data).then(res => {
                 if (res.status) {
                  Modal.success({
                    title: `success`,
                    content: `${res.message}`,
                    zIndex: '1022',
                    okText: "Ok",
                    cancelText: "Cancel",
                    onOk: function () {
                      This.setState({ loadding: false, tbody: [] })
                      This.loadPage();

                    }
                  });

                } else {
                  Modal.error({
                    title: `Failure`,
                    content: `${res.message}`,
                    zIndex: '1022'
                  });
                  This.setState({ loadding: false })
                }

              })
            } catch (error) {
          
              This.setState((state) => ({ 'loadding': false }));
              Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
                zIndex: '1022'
              })

            }
          }
          ,
          onCancel() {
         
            This.setState({ loadding: false })
          },
        });
      } else {
        let This = this
        try {
          This.setState({ loadding: true })
          formDataPostService('profileUploadForDoctor', 'POST', form_data).then(res => {
            if (res.status) {
              Modal.success({
                title: `success`,
                content: `${res.message}`,
                zIndex: '1022',
                okText: "Ok",
                cancelText: "Cancel",
                onOk: function () {
                  This.setState({ loadding: false, tbody: [] })
                  This.loadPage();
                }
              });
            } else {
              Modal.error({
                title: `Failure`,
                content: `${res.message}`,
                zIndex: '1022'
              });
              This.setState({ loadding: false })
            }

          })
        } catch (error) {
        
          This.setState((state) => ({ 'loadding': false }));
          Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
            zIndex: '1022'
          })

        }
      }

    } else {
      Modal.error({
        title: `Failure`,
        content: `Oops, something went wrong. Please try again.`,
        zIndex: '1022'
      });
      this.setState({ loadding: false })
    }

  }
  deleteProfile(data) {
    let payload = {
      "id": data.id,
    }
    let This = this;
    Modal.confirm({
      title: `Confirmation`,
      content: `Are You sure you want to delete doctor image?.`,
      zIndex: '1022',
      okText: "Delete",
      cancelText: "Cancel",
      onOk: function () {
        try {
          postService('getDoctorIdProfileDelete', "POST", { data: payload }).then((res) => {
            if (res.status) {
              Modal.success({
                title: `success`,
                content: `Deleted the  Doctor image `,
                zIndex: '1022'
              });
              This.loadPage();
            } else {
              Modal.error({
                title: `Failure`,
                content: `Oops, something went wrong. Please try again.`,
                zIndex: '1022'
              });
            }
          });
        } catch (error) {
          console.log(error);
          This.setState((state) => ({ 'loadding': false }));
          Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
            zIndex: '1022'
          })
        }
      },
      onCancel() {
        console.log('Cancel');
      },
    })

  }
  viewProfile(data) {
    if (data.profile_pic !== '' && data.profile_pic !== null && data.profile_pic !== undefined) {
      this.setState((state) => ({ viewimage: true, doctorImage: data.profile_pic }));
    }

  }

  handleKeyDown(event) {
    if (event.key === 'Enter') {
      const inputValue = event.target.value; // Get the input value
      this.setState({ search_key: inputValue }); // Update the search_key state
      this.searchClick();
    }
  }

  fetchMatchingRecords = (value) => {
    const data = this.state.tbody;
  };


  render() {
    let { slug } = this.props.match.params;
    const { tv_base_url } = networkList;
    const isView = slug === "floors" || slug === "blocks";
    const { search_key } = this.state;
    let {
      totalItemsCount,
      tableTitle,
      thead,
      tbody,
      addText,
      showAdd,
      showEdit,
      activePage,
      showPagination,
      loadding,
      fetching,
      doctorList,
      pageSize,
      showFilter,
      formData,
      uid,
      fileList,
      doctorImage
    } = this.state;
    // console.log("thead%%%%%%%%%%%%%%",thead,"tbody%%%%%%%%%%%%",tbody);
    let { doctor_profile_url } = networkList;
    let placeholderText = "";

    if (slug === "doctors") {
      placeholderText = "Search by Doctor Name, Code & Department";
    } else if (slug === "users") {
      placeholderText = "Search by User Name & Role";
    } else if (slug === "services") {
      placeholderText = "Search by Service, Code & Service Group";
    }
    else if (slug === "departments") {
      placeholderText = "Search by Department Name & Code";
    }
    return (
      <React.Fragment>
        <div className="row mb-2 mr-5 sticky-top" style={{ paddingTop: "2px" }}>
          <div className="col-8">
            {(showFilter) &&
              <div className="col-12 float-left ml-5">
                {(formData !== undefined) && <React.Fragment>
                  <div className='row'>
                    {formData
                      .map((feild, key) => {
                        if (feild.element === 'input') {
                          return (
                            // <div>
                            // <div class="input-group col-12 pl-0">
                            //   <input type="text" id="myInput" class="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="SEARCH DOCTOR NAME"  onKeyDown={this.handleKeyDown.bind(this)}  onChange={this.searchChange.bind(this)} 
                            //   ></input>
                            //   <div class="input-group-append">
                            //     <button class="btn btn-success btn-sm p-1" type="button" onClick={this.searchClick.bind(this)}><img src="/assets/images/icons/search.png"></img></button>
                            //   </div>              
                            // </div>
                            // </div>
                            <div>
                              <div className="input-group col-12 pl-0">

                                <AutoComplete
                                  style={{ width: 300 }}
                                  value={search_key}
                                  placeholder={placeholderText}
                                  onChange={(value) =>{ this.setState({ search_key: value });
                                  this.updatesearchkey(value);
                                }}
                                  
                                //  onSearch={this.state.search_key.length>0?this.searchClick.bind(this):this.searchClick1.bind(this)}
                                />
                                <div className="input-group-append">
                                  <button class="btn btn-success btn-sm p-1" type="button" onClick={this.searchClick.bind(this)}><img src="/assets/images/icons/search.png"></img></button>
                                </div>
                              </div>
                            </div>
                          )
                        }
                        // if (feild.element === 'select2') {
                        //     if(feild.name==='department'){
                        //         return (
                        //             <div className='col-4'>
                        //                         <Select2 selectdata={feild} changedObj={this.state.changedObj} {...this.props} {...this.state} Queuedata={this.state.formData} onselectChanges={this.handleChange.bind(this)} />
                        //                         {feild.errors.map((error, eKey) => {
                        //                             return (
                        //                                 <small key={eKey} className="form-text text-danger">{error.message}</small>
                        //                             );
                        //                         })}
                        //                     </div>
                        //         )
                        //     }
                        //     else{
                        //     return (
                        //         <div class="col-4">
                        //             <div className='row'>
                        //                 <React.Fragment key={key}>
                        //                     <div className={`${feild.className ? feild.className : 'col '} ${feild.name}`}
                        //                         key={key} >
                        //                         <p className="data-label text-white w-75 mb-1 pt-1 text-right pr-2">{feild.text2}</p>
                        //                     </div>
                        //                     <div className='col-6'>
                        //                         <Select2 selectdata={feild} changedObj={this.state.changedObj} {...this.props} {...this.state} Queuedata={this.state.formData} onselectChanges={this.handleChange.bind(this)} />
                        //                         {feild.errors.map((error, eKey) => {
                        //                             return (
                        //                                 <small key={eKey} className="form-text text-danger">{error.message}</small>
                        //                             );
                        //                         })}
                        //                     </div>
                        //                 </React.Fragment>
                        //             </div>
                        //         </div>
                        //     )
                        //  }
                        // }
                      })}

                  </div>
                </React.Fragment>}
              </div>
            }
          </div>
          <div className="col-4 pr-0">
            {showAdd && (
              <button
                className="btn btn-success text-capitalize float-right"
                onClick={this.addUser}
              >
                add {addText}
              </button>
            )}
          </div>
        </div>
        <Spin spinning={loadding}>
          <div className="card ml-5 mr-5 mb-2 card-table">
            <div className=" bg8">
              <div className="clearfix">
                {/* <div className="float-left pt-1">{tableTitle}</div> */}
                {/* <div className="row search-width">
                  <div className="col-6 mx-auto">
                    {slug === "doctors" && (
                      <Select
                        showSearch
                        mode="single"
                        style={{ width: "100%" }}
                        onChange={this.selectedDoctor.bind(this)}
                        onSearch={this.doctorList}
                        notFoundContent={
                          fetching ? (
                            <Spin size="small" />
                          ) : (
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                          )
                        }
                        filterOption={false}
                        placeholder="Doctor Name"
                      >
                        <Option key={0} value={0} defaultValue={{ value: 0 }}>
                          All
                        </Option>
                        {doctorList.map((data, key) => {
                          return (
                            <Option key={key} value={data.id}>
                              {data.name}
                            </Option>
                          );
                        })}
                      </Select>
                    )}

                    {slug === "doctors" ? (
                      <div
                        class="input-group-append"
                        style={{
                          position: "absolute",
                          top: "0px",
                          right: "8px",
                          height: "32px",
                        }}
                      >
                        <button
                          class="btn btn-primary btn-sm"
                          style={{ cursor: "default" }}
                        >
                          <img src="/assets/images/icons/search.png" />
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div> */}
              </div>
            </div>
            <div className="financial-table table-responsive">
              <table className="table table-hover table-bordered mb-0">
                <thead>
                  <tr>
                    {thead.map((head, key) => {
                      return (
                        <td className="text-capitalize" key={key}>
                          {head["text"]}
                        </td>
                      );
                    })}
                  </tr>
                </thead>
                {tbody != "" ? (
                  <tbody>
                    {/* {tbody.map((body, key) => { */}
                    {tbody.map((body, key) => {
                      return (
                        <tr key={key}>
                          {thead.map((head, Hkey) => {
                            if (head["key"] === "s_no") {
                              // return (<td>{key + 1}</td>)
                              return (
                                <td>
                                  {key +
                                    1 +
                                    (activePage > 1
                                      ? 20 *
                                      (activePage > 2 ? activePage - 1 : 1)
                                      : 0)}
                                </td>
                              );
                            }
                            if (head["key"] === "action") {
                              return (
                                <td>
                                  {showEdit && (
                                    <Tooltip title="Edit">
                                      <Button
                                        type="link"
                                        icon= {<EditOutlined style={{ fontSize: '17px',marginLeft:"3px" }}/>}
                                        style={{
                                          color: "#6c3964",
                                          "font-size": "20px",
                                        }}
                                        onClick={this.editclick.bind(
                                          this,
                                          body
                                        )}
                                      />
                                      {/* <img
                                        src="/assets/images/icons/edit.png"
                                        alt="edit"
                                        className="mr-2"
                                        onClick={this.editclick.bind(
                                          this,
                                          body
                                        )}
                                      />{" "} */}
                                    </Tooltip>
                                  )}
                                  {!isView && slug !== "service-group" && (
                                    <Tooltip title="View">
                                      <Button
                                        type="link"
                                        icon={<EyeOutlined style={{ fontSize: '17px',marginLeft:"25px" }} />}
                                        style={{
                                          color: "#6c3964",
                                          "font-size": "20px",
                                         
                                        }}
                                        onClick={this.viewDetails.bind(
                                          this,
                                          body
                                        )}
                                      />
                                      {/* <img
                                        src="/assets/images/icons/view.png"
                                        alt="view"
                                        onClick={this.viewDetails.bind(
                                          this,
                                          body
                                        )}
                                      /> */}
                                    </Tooltip>
                                  )}
                                </td>
                              );
                            }
                            if (head["key"] === "status") {
                              return (
                                <React.Fragment>
                                  {showEdit && (
                                    <React.Fragment>
                                      {body.status !== undefined &&
                                        body.status !== null &&
                                        (body.status === 1 ||
                                          body.status === "1") && (
                                          <td>
                                            <Switch
                                            style={{
                                              backgroundColor: "#6c3964",}}
                                              defaultChecked
                                              onChange={(status) =>
                                                this.onChange(status, body)
                                              }
                                            />
                                          </td>
                                        )}
                                      {((body.status !== undefined &&
                                        body.status === null) ||
                                        body.status === 0 ||
                                        body.status === "0") && (
                                          <td>
                                            <Switch
                                              onChange={(status) =>
                                                this.onChange(status, body)
                                              }
                                            />
                                          </td>
                                        )}{" "}
                                    </React.Fragment>
                                  )}
                                  {!showEdit && (
                                    <td>
                                      {body.status && body.status !== null
                                        ? body.status === "1"
                                          ? "Active"
                                          : "Inactive"
                                        : "--"}
                                    </td>
                                  )}
                                </React.Fragment>
                              );
                            }
                            if (head["key"] === "vitals_required") {
                              return (
                                <React.Fragment>
                                  {showEdit && (
                                    <React.Fragment>
                                      {body["vitals_required"] !== undefined &&
                                        body["vitals_required"] !== null &&
                                        (body["vitals_required"] === true ||
                                          body["vitals_required"] === "true") && (
                                          <td>
                                            <Switch
                                            style={{
                                              backgroundColor: "#6c3964",}}
                                              defaultChecked
                                              onChange={() =>
                                                this.onChange("vitals_required_false", body)
                                              }
                                            />
                                          </td>
                                        )}
                                      {((body["vitals_required"] !== undefined &&
                                        body["vitals_required"] === null) ||
                                        body["vitals_required"] === false ||
                                        body["vitals_required"] === "false") && (
                                          <td>
                                            <Switch
                                              onChange={() =>
                                                this.onChange("vitals_required_true", body)
                                              }
                                            />
                                          </td>
                                        )}{" "}
                                    </React.Fragment>
                                  )}
                                  {!showEdit && (
                                    <td>
                                    {body["vitals_required"]?"YES":"NO"}
                                  </td>
                                  )}
                                </React.Fragment>
                              );
                            }
                            if (head["key"] === "queue_list") {
                              return (
                                <td className="text-capitalize">
                                  <table className="table table-condensed">
                                    {body[head["key"]] !== null &&
                                      (body["queue_list"] &&
                                        body["queue_list"].length
                                        ? body["queue_list"].map((q, i) => (
                                          <tr key={i}>
                                            <td>
                                              {`${q["queue_list_id"]
                                                ? q["queue_list_id"]
                                                : "NA"
                                                }`}{" "}
                                              -{" "}
                                              {`${q["queue_list_name"]
                                                ? q["queue_list_name"]
                                                : "NA"
                                                }`}
                                            </td>
                                          </tr>
                                        ))
                                        : "--")}
                                  </table>
                                </td>
                              );
                            }
                            if (head["key"] === "unitids") {
                              return (
                                <td>
                                  {body[head["key"]] !== null &&
                                    (body["unitids"] && body["unitids"].length > 0
                                      ? body["unitids"].map(
                                        (unit, i) =>
                                          `${i + 1} - ${unit["unitname"]}, `
                                      )
                                      : "--")}
                                </td>
                              );
                            }
                            if (head["key"] === "display_name" && head['text'] === "Display Link") {
                              return (
                                <td>
                                  {/* {tv_base_url+'tv-screen/'+body["display_name"]+'?uid='+body["unit"]} */}
                                  <a href={tv_base_url + 'tv-screen/' + body["display_name"] + '?uid=' + body["unit"]} target="_blank" rel="noopener noreferrer" >{tv_base_url + 'tv-screen/' + body["display_name"] + '?uid=' + body["unit"]}</a>
                                </td>
                              );
                            }
                            if (head["key"] === "profile_pic") {
                              return (
                                <td className="doctor_list">
                                  <div className="row">

                                    <div className="col-3">
                                      {showEdit && (<Upload action={null} fileList={fileList} onChange={this.handle2Change} beforeUpload={(file) => { this.setState({ body: body }) }}>
                                        <Tooltip title="Click here to upload">
                                          <CloudUploadOutlined className={body && body.profile_pic !== null && body.profile_pic !== '' && body.profile_pic !== undefined ? "profile_pic profile_green" : "profile_pic"} />
                                          {/* <AntCloudOutlined /></Button> */}
                                          {/* <Button><i class="fa fa-cloud-upload" aria-hidden="true"></i></Button> */}

                                        </Tooltip>
                                      </Upload>)}
                                    </div>

                                    <div className="col-6">
                                      <a onClick={this.viewProfile.bind(this, body)}>
                                        <img
                                          alt=""
                                          src={
                                            body && body.profile_pic
                                              ? doctor_profile_url + body.profile_pic + '?' + new Date().getTime()
                                              : "/assets/images/newProfile.png"
                                          }
                                          className="doctor_profile_pic"
                                        />
                                      </a>
                                    </div>
                                    {showEdit && (body && body.profile_pic !== '' && body.profile_pic !== null && body.profile_pic !== undefined) && (<div className="col-3">
                                      <Tooltip title="Remove Image">
                                        <DeleteOutlined className="delete_profile" onClick={this.deleteProfile.bind(this, body)} />
                                      </Tooltip>
                                    </div>)}
                                  </div>
                                  {/* <React.Fragment> */}

                                </td>
                              );
                            }
                            return (
                              <td >
                                {body[head["key"]] !== null
                                  ? body[head["key"]]
                                  : "--"}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan="13" className="text-center">
                        <img src="/assets/images/icons/no-data.svg" alt="" />
                        <p className="no-data mb-0">No Data</p>
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>
          <div className="row justify-content-center align-item-center mx-0">
            <div className="col pagenation-col mb-3" >
              {showPagination && (
                <Pagination
                  current={this.state.activePage}
                  total={totalItemsCount}
                  itemRender={this.itemRender.bind(this)}
                  pageSize={20}
                  onChange={this.handlePageChange.bind(this)}
                  size="large"
                />
              )}
            </div>
          </div>
          <Modal centered visible={this.state.viewimage} width='25%' footer={null} zIndex={1021} destroyOnClose={true}
          >
            <React.Fragment>
              <img src={doctor_profile_url + doctorImage + '?' + new Date().getTime()} className="w-100 h-100"></img>
            </React.Fragment>
            <div className="fc-patient-copy">
              <div className="row justify-content-center p-4 pt-4 m-0 estimate-print-btn">
                <button className="btn d-print-none btn-next text-capitalize ml-3" onClick={() => this.setState({ viewimage: false })}>cancel</button>
              </div>
            </div>
          </Modal>
        </Spin>
      </React.Fragment>
    );
  }
}

export default User_List;